// import components
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import { CenterTitle, LeftTitle } from "../Components/Titles";
import { FounderText, OurStoryText } from "../Components/TextMoreLess";
import { Services } from "../Components/Services";
import { Industries } from "../Components/Industries";

// import images
import aboutImage from "../Assets/Images/2.jpg";
import founderImage from "../Assets/Images/founder2.png";
import { Logo } from "../Components/Logo";
import { FooterLinks } from "../Components/FooterLinks";
import bgImage from "../Assets/Images/1.png";

// import icons
import linkendInIcon from "../Assets/Icons/social-white.png";

function HomePage() {


    return (
        <div className="home" id="home">
            <NavBar />
            <Header />
            <main>
                <div className="wrapper">
                    <div className="main-about" id="about">
                        <div className="left">
                            <div className="outline" />
                            <img src={aboutImage} alt="about img" />
                        </div>
                        <div className="right">
                            <LeftTitle head={"About Us"} title={"Our Story"} />
                            <div className="text">
                                <OurStoryText />
                            </div>
                        </div>
                    </div>
                    <div className="main-about-btm">
                        <div className="left">
                            <LeftTitle head={"About Us"} title={"Our Vision"} />
                            <div className="text">
                                <p>At Page Partners, our vision is to be the leading talent partner in the engineering sector, recognized for our passion for people, exceptional service delivery, and commitment to innovation. We aim to connect specialized engineering talent with forward-thinking organizations, fostering relationships that empower both professionals and businesses to thrive. By leveraging advanced technologies, promoting sustainability, and embracing diversity, we aspire to shape a dynamic and inclusive engineering industry that drives global progress.</p>
                            </div>
                        </div>
                        <div className="right">
                            <LeftTitle head={"About Us"} title={"Our Mission"} />
                            <div className="text">
                                <p>To empower the engineering sector by bridging exceptional talent with groundbreaking opportunities. With a focus on integrity, innovation, and personalized service, we build lasting partnerships that elevate careers and drive industry success. By addressing key recruitment challenges, promoting workforce readiness, and operating seamlessly across international markets, we contribute to the continuous growth and advancement of the engineering field.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="services" id="services">
                    <div className="wrapper">
                        <div className="services-wrap">
                            <CenterTitle head={"services"} title={"Services we provide"} headStatus={true} />
                            <Services />
                        </div>
                    </div>
                </div>

                <div className="wwd" style={{ backgroundImage: `url(${bgImage})`}}>
                    <div className="bg" />
                    <img src={bgImage} alt="bgImage" />
                    <div className="wwd-text">
                        <div className="text-wrap">
                            <CenterTitle head={""} title={"Who We Are"} headStatus={false} />
                            <div className="line" />
                            <p>Page Partners is a dynamic and dedicated recruitment firm specialising in connecting top talent with leading organisations. Our mission is to transform businesses by sourcing and placing exceptional candidates who drive success. We also specialise on skilled appointments and headhunting services across a wide range of commerce and industry sectors with more than 10 years of industry leading expertise with a successfully tried and tested Talent Acquisition Methodologies.</p>
                        </div>
                    </div>
                </div>

                <div className="wrapper">
                    <div className="industries" id="industry">
                        <CenterTitle head={"Industries"} title={"We serve a diverse range of industries"} headStatus={true} />
                        <Industries />
                    </div>

                    <div className="founder">
                        <div className="founder-wrap" id="founder">
                            <div className="right" id="on-small-screen">
                                <div className="outline" />
                                <img src={founderImage} alt="founder" />
                            </div>
                            <div className="left">
                                <div className="founder-title">
                                    <LeftTitle head={"Founder"} title={"Meet The Founder of Page Partners"} headStatus={true} />
                                </div>

                                <div className="text" >
                                    <p>Hi, I am <span className="name">Pandy Kasumba</span>, and this is my story.</p>
                                    {/* <p>20+ years in recruitment | Industrial Psychology | People & Partnerships</p> */}
                                    <FounderText />
                                     
                                    <a href="https://blinq.me/cm85moogo03xds60l37pnz1c6" target="_blank" rel="noopener noreferrer" title="Business Card">my business card</a>
                                     
                                </div>
                            </div>
                             <div className="right">
                                <div className="outline" />
                                <img src={founderImage} alt="founder" />
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <footer id="contact" style={{ backgroundImage: `url(${bgImage})`}}>
                <div className="footer-bg" />
                <img src={bgImage} alt="bgImage" className="bgImg" />
                <div className="wrapper">
                    <div className="footer-wrap">
                        <Logo />
                        <div className="left">
                            {/* <div className="line" /> */}
                            <div className="text">
                                <p>
                                    Welcome to Page Partners
                                    <br /><br />
                                    At Page Partners, our journey began with a passion, a passion for Recruiting Strategically sourced and curated talent for connecting exceptional talent with our stakeholders in placing Top Talent.
                                </p>
                                <a href="https://za.linkedin.com/in/pandy-ntombela-kasumba-b69338182" target="_blank" rel="noopener noreferrer" title="LinkedIn"><img src={linkendInIcon} alt="linkedin" /></a>
                            </div>

                        </div>
                        <div className="center">
                            <FooterLinks />
                        </div>

                        <div className="right">
                            <div className="right-title">
                                <h3>Contact Us</h3>
                                <p>Get in touch with us</p>
                            </div>
                            <div className="text">

                                <p>
                                    <span>Office Line:</span> 010 001 5276
                                    <br />
                                    <span>Mobile Number:</span> 082 600 2410
                                </p>

                                <p>
                                    <span>Email Address:</span><br />
                                    info@pagepartners.co.za <br />
                                    cv@pagepartners.co.za
                                </p>

                                <p>
                                    <span>Physical Address:</span><br />
                                    29/30 Richard Road,
                                    Fourways 2191
                                </p>
                            </div>
                        </div>

                        <div className="linkedIn">
                            {/* <button><img src={linkendInIcon} alt="linkendIn" /></button> */}
                            <a href="https://www.linkedin.com/in/pandy-ntombela-kasumba-b69338182?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" title="LinkedIn"><img src={linkendInIcon} alt="linkedin" /></a>
                        </div>
                    </div>

                    <div className="footer-btm">
                        <div className="footer-btm-wrap">
                            <p>© 2025 Page Partners. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default HomePage;